module.exports = __webpack_public_path__ + "img/A-851-880.36ac4cd0.svg";